import React, { useEffect, useRef, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import AppContext from "../context/AppContext";
import ConfirmButton from "./ConfirmButton";

export default function TanksOptions() {
    const { t } = useTranslation();
    const { sharetanks, tanksdata, showTanks, updateLoading } = useContext(AppContext);


    const closeShare = () => {
        showTanks(false);
    }

    const selectionShare = (item) => {
        console.log(item)
        updateLoading(true);
        const formData = new FormData();
        formData.append("child_id", tanksdata?.id);
        formData.append("position", item);
        fetch(`${process.env.REACT_APP_BACKEND}/binary-child`, {
            method: "POST",
            body: formData,
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.status) {
                    toast.error(t("_NETWORK._ERROR"));
                    updateLoading(false);
                } else {
                    toast.success(t("_NETWORK._BINARYSUCCESS"));
                    showTanks(false);
                    updateLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                updateLoading(false);
            });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.classList.add('overflow-y-hidden');
        return () => {
            document.body.classList.remove('overflow-y-hidden');
        };
    }, []);


    return (
        <>
            <div className="w-screen absolute h-full" style={{ zIndex: "100", backgroundColor: "#00000091" }}>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  custom-button-shadow-two rounded p-10 bg-zinc-800 w-11/12 lg:w-3/5">
                    <div className="flex justify-end cursor-pointer" onClick={() => closeShare()}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 text-blue-300 text-end">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </div>
                    <div className="flex flex-col w-full justify-center items-center">
                        <h2 className="text-white">{tanksdata?.name || "Loading.."}</h2>
                        <h2 className="text-white">{t("_LOGIN._EMAIL")}: {tanksdata?.email || "Loading.."}</h2>
                        <h2 className="text-center my-2 text-red-400">{t("_NETWORK._BINARYTEXT")}</h2>
                        <div className="flex flex-col lg:flex-row w-full gap-2 my-4 relative justify-center">
                            <ConfirmButton text={t("_NETWORK._LEFT")} direction={"left"} onComplete={() => selectionShare("left")} />
                            <ConfirmButton text={t("_NETWORK._RIGHT")} direction={"right"} onComplete={() => selectionShare("right")} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
